import { FunctionComponent } from "react";
import Image from "next/image";
import { Add1Icon } from "@form/components/common/icons";
import Link from "next/link";
import { getRoute } from "@/services/config";

const Guide: FunctionComponent = () => {
  return (
    <div className="flex flex-col items-center">
      <img
        src="/assets/analytic-guide.png"
        className="w-[440px] block mr-[-20px]"
      ></img>

      <Link href={getRoute("analytics_create").route}>
        <div className="flex items-center h-10 w-36 justify-center mt-6 bg-primary rounded-full ml-2 hover:cursor-pointer hover:bg-primary/80">
          <Add1Icon className="fill-white w-5"></Add1Icon>
          <div className="text-white font-semibold ml-2">Create new</div>
        </div>
      </Link>
    </div>
  );
};

export default Guide;
